import React from 'react'
import './More3.css';

const More3 = () => {
  return (
    <div>
      <div className="section110">
          <div className="container110">
            <div className="content-section110">
              <div className="title110">
                <h1>Fibc Jumbo Bags</h1>
              </div>
              <div className="content110">
                <h3>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Excepturi quasi odio, numquam fugiat illum similique!</h3>
                {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p> */}
                {/* <div className="button">
                  <a href="">Read More</a>
                </div> */}
              </div>
              <div className="social">
                {/* <a href=""><i className='fab fa-facebook-f'></i></a>
                <a href=""><i className='fab FaTwitter'></i></a>
                <a href=""><i className='fab fa-instagram'></i></a> */}
              </div>
            </div>
            {/* <div className="image-section">
              <img src="/images/6.jpg" alt="" />
            </div> */}
          </div>
        </div>
    </div>
    
  )
}

export default More3
